
import { AreaInterest } from "../../classes"
import Store from "../../store"
const AreaInterestModule = {
  namespaced: true,
  state: () => ({
    areaInterest: null,
    isLoading: false
  }),
  actions: {
    createAreaInterest: async ({ commit }, payload) => {
      try {
        let user = Store.getters['user/getUser']
        commit("setAreaInterest", null);
        commit("setIsLoading", true);
        const data = await AreaInterest.createAreaInterest(payload, user ? user : null);
        commit("setAreaInterest", data);
        commit("setIsLoading", false);
        return data;
      } catch (err) {
        commit("setIsLoading", false);
        return err;
      }
    }
  },
  getters: {
    getAreaInterest: state => state.areaInterest,
    getIsLoading: state => state.isLoading,
  },
  mutations: {
    setAreaInterest: (state, areaInterest) => {
      state.areaInterest = areaInterest;
    },
    setIsLoading: (state, isLoading) => {
      state.isLoading = isLoading;
    },
  },
};
export default AreaInterestModule;
